import { render, staticRenderFns } from "./pcUserNavComponent.vue?vue&type=template&id=17c9920e&scoped=true"
import script from "./pcUserNavComponent.vue?vue&type=script&lang=js"
export * from "./pcUserNavComponent.vue?vue&type=script&lang=js"
import style0 from "./pcUserNavComponent.vue?vue&type=style&index=0&id=17c9920e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c9920e",
  null
  
)

export default component.exports